module.exports = __webpack_public_path__ + "static/copmi-e7f8c05133d353a6d488fdff40320ab2.png";